import React from "react";
import { LoaderContext } from "./loader-context";
import { useContextLoaderHook } from "./loader-hooks";

export function ContextLoaderProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const value = useContextLoaderHook();

  return (
    <LoaderContext.Provider value={value}>{children}</LoaderContext.Provider>
  );
}
